import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedSize from 'I18n/components/FormattedSize';
import { fileIsImage } from 'conversations-internal-schema/file-upload/operators/fileIsImage';
import { getUploadProgress, getFile } from 'conversations-internal-schema/file-upload/operators/fileUploadGetters';
import { uploadedBytes } from 'conversations-internal-schema/file-upload/operators/uploadedBytes';
import { getFileName } from 'conversations-internal-schema/file-upload/operators/getFileName';
import { getFileSize } from 'conversations-internal-schema/file-upload/operators/getFileSize';
import { isUploadCompleted } from 'conversations-internal-schema/file-upload/operators/isUploadCompleted';
import ImageAttachmentPreview from './ImageAttachmentPreview';
import VizExNanoProgress from 'visitor-ui-component-library/progress/VizExNanoProgress';
import VizExFileAttachment from 'visitor-ui-component-library/file/VizExFileAttachment';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FileUpload extends Component {
  customFilePreview() {
    const attachment = this.props.attachment;
    const file = getFile(attachment);
    if (!file || !fileIsImage(file)) {
      return undefined;
    }
    return /*#__PURE__*/_jsx(ImageAttachmentPreview, {
      imageFile: file
    });
  }
  fileInfo() {
    if (isUploadCompleted(this.props.attachment)) {
      return /*#__PURE__*/_jsx(FormattedSize, {
        value: getFileSize(this.props.attachment)
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-ui.stagedAttachment.uploadProgress",
      options: {
        uploadedBytes: I18n.formatSize(uploadedBytes(this.props.attachment), {
          precision: 2,
          strip_insignificant_zeroes: true
        }),
        totalBytes: I18n.formatSize(getFileSize(this.props.attachment))
      }
    });
  }
  renderProgress() {
    if (isUploadCompleted(this.props.attachment)) {
      return null;
    }
    return /*#__PURE__*/_jsx(VizExNanoProgress, {
      value: getUploadProgress(this.props.attachment)
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(VizExFileAttachment, {
      processing: !isUploadCompleted(this.props.attachment),
      fileName: getFileName(this.props.attachment),
      fileInfo: this.fileInfo(),
      preview: this.customFilePreview(),
      style: {
        minWidth: 220
      },
      children: [/*#__PURE__*/_jsx(VizExCloseButton, {
        size: "xs",
        onClick: this.props.onRemove
      }), this.renderProgress()]
    });
  }
}
FileUpload.displayName = 'FileUpload';
export default FileUpload;